<template>
    <div v-if="dispatchRequest">
        <h3>Print pakbon</h3>

        <p v-if="hasPermission('orders.dispatchrequests.downloadpackingslip')">
            Klik hier om te downloaden:
            <download-packing-slip-button :dispatch-request="dispatchRequest" :always-show="true" variant="secondary" class="p-2">
                Download pakbon (en label)
            </download-packing-slip-button>
            <print-labels-button :dispatch-request="dispatchRequest" class="ml-2"/>
        </p>

        <b-button @click="$emit('success', {})" variant="primary">Ga verder</b-button>
    </div>
    <span v-else class="text-danger">
        Pakbon niet beschikbaar
    </span>
</template>

<script>
import DownloadPackingSlipButton from "../../OrderDetail/components/DownloadPackingSlipButton.vue";
import PrintLabelsButton from "@/views/OrderDetail/components/PrintLabelsButton.vue";

export default {
    name: "SpecialProcessPrintPackingSlip",
    components: {PrintLabelsButton, DownloadPackingSlipButton},

    props: {
        dispatchRequest: {required: true},
    },

    data() {
        return {}
    },

    computed: {},

    mounted() {

    },

    methods: {
        getIdentifier() {
            return 'print_packing_slip'
        },
        isRequired(batchModelType, productIdentifier, dispatchRequest, sortingLocation, isLastScan) {
            return Promise.resolve(dispatchRequest && !sortingLocation.identifier)
        },
        onShow() {
        },
    },
}
</script>

<style scoped>

</style>
